import {
  AfterViewInit, Component, ComponentFactoryResolver, ElementRef, HostListener, OnChanges, OnDestroy,
  OnInit, SimpleChanges, TemplateRef, ViewChild, ViewContainerRef, NgZone
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CarsService } from '../cars.service';
import { faHeart as fasFaHeart, faShoppingCart } from '@fortawesome/free-solid-svg-icons';
import { faHeart as farFaHeart } from '@fortawesome/free-regular-svg-icons';
import { CarDialogOverviewComponent } from '../../cars/car-dialog-overview/car-dialog-overview.component';
import { CarModalComponent } from '../../cars/car-modal/car-modal.component';
import { NbDialogConfig, NbDialogService } from '@nebular/theme';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { CalculatorCarsComponent } from '../../calculator/calculator-cars.component';
import { BehaviorSubject, forkJoin } from 'rxjs';
import { CalculatorService } from '../../calculator/calculator.service';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { AuthenticateService } from '../../auth/authenticate.service';
import { ChangeContext, LabelType, Options } from '@angular-slider/ngx-slider';
import { CurrencyPipe } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { CognitoService } from '../../cognito.service';
import { LoginModalComponent } from '../../auth/login/login-modal.component';
import { AcceptTermsComponent } from '../../cars/accept-terms/accept-terms.component';
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';
import { CookieService } from 'ngx-cookie-service';
import { faTags as fasTags, faCertificate as fasCertificate} from '@fortawesome/free-solid-svg-icons';
import {ArbitrageTermsNigeriaComponent} from '../arbitrage-terms-nigeria/arbitrage-terms-nigeria.component';
import {CarModalSellerNigeriaComponent} from '../car-modal-seller-nigeria/car-modal-seller-nigeria.component';
import {CarModalNigeriaComponent} from '../car-modal/car-modal-nigeria.component';
import {NgcCookieConsentService} from 'ngx-cookieconsent';
import { CarModalDialogContext } from '../dialogs/car-modal-dialog-context';
import { NigeriaPriceService } from '../nigeria-price.service';
import { LanguageService } from '../../services/language.service';

// import {CarModalSellerComponent} from '../../cars/car-modal-seller/car-modal-seller.component';

// import {ComponentPortal, TemplatePortal} from '@angular/cdk/portal';

export interface Model {
  name: string;
  fuelType: string;
  fuelType_h: string;
}

export interface FilterMeta {
  year: number;
  make: string;
  make_h: string;
  model: Model[];
}

export interface DialogData {
  car: any;
}

declare let dataLayer: Array<any>;

@Component({
  selector: 'app-cars-grid-seller-nigeria',
  templateUrl: './cars-grid-seller-nigeria.component.html',
  styleUrls: ['./cars-grid-seller-nigeria.component.scss'],
  animations: [
    trigger('fadeAnimation', [
      transition('* <=> *', [
        query(':enter', [
          style({ opacity: 0 }),
          stagger('100ms', animate('300ms ease-in', style({ opacity: 1 })))
        ], { optional: true }),
        query(':leave', [
          animate('300ms ease-out', style({ opacity: 0 }))
        ], { optional: true })
      ])
    ])
  ]
})
export class CarsGridSellerNigeriaComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @ViewChild('carContainer') carContainer: ElementRef;
  @ViewChild('loadingOverlay') loadingOverlay: TemplateRef<any>;

  fasTags = fasTags;
  faCertificate = fasCertificate;

  currencyPipe = new CurrencyPipe('he-il');
  target: any;

  overlayRef: OverlayRef;

  loading = false;
  hasMore = true;

  page = 1;

  // member-ordering: fields must be defined before methods
  private activeDialogRef: any = null;
  private filterLock = false;
  private filterDebounce: any;

  private sliderChangeTimer: any;
  private filterInProgress = false;
  private lastFilterValues = {
    priceLow: 0,
    priceHigh: 0,
    kmLow: 0,
    kmHigh: 0,
    tab: 0
  };

  // private sliderChangeTimer: any;
  private lastSliderRange = {
    price: { low: 0, high: 0 },
    km: { low: 0, high: 0 }
  };

  // price range
  sliderValue = 0;
  sliderHighValue = 200000; // USD landed-cost ceiling (~99.95% of inventory); labels shown in NGN
  sliderOptions: Options = {
    floor: 0,
    ceil: 200000,
    step: 1000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  // km range
  sliderKmValue = 0;
  sliderKmHighValue = 1000000;
  sliderKmOptions: Options = {
    floor: 0,
    ceil: 1000000,
    step: 10000,
    rightToLeft: true,
    animate: true,
    pushRange: true,
    animateOnMove: true,
    showSelectionBar: true,
    hideLimitLabels: false,
    autoHideLimitLabels: false,
    ticksTooltip: (value: number): string => {
      return '';
    },
    selectionBarGradient: {
      from: '#00ff00',
      to: '#ff0000'
    },
    translate: (value: number, label: LabelType): string => {
      return '';
    }

  };

  // --- Normal filters ---
  filterMetaNormal: any = {};
  yearsNormal = ['All'];
  makesNormal = ['All'];
  modelsNormal = ['All'];
  fuelTypesNormal = ['All'];
  selectedYearNormal = 'All';
  selectedMakeNormal = 'All';
  selectedModelNormal = 'All';
  selectedFuelTypeNormal = 'All';

  // --- Damaged filters ---
  filterMetaDamaged: any = {};
  yearsDamaged = ['All'];
  makesDamaged = ['All'];
  modelsDamaged = ['All'];
  fuelTypesDamaged = ['All'];
  selectedYearDamaged = 'All';
  selectedMakeDamaged = 'All';
  selectedModelDamaged = 'All';
  selectedFuelTypeDamaged = 'All';

  locatedInIsrael: 'All' | 'Yes' | 'No' = 'All';
  saleCondition: 'All' | 'New' | 'Used' = 'All';
  importType: 'Commercial' | 'Taxi' = 'Commercial';
  year = -1;
  make = '';
  model = '';
  fueltype = '';
  priceRange = '0-200000';
  kmRange = '0-1000000';

  tabSelectionEnabled = true;
  selectedTab = 0;

  sellerId = 530;

  // --- Best Deals filters/results ---
  bestDealsCars: any[] = [];
  fetchedBestDealsCars: any[] = [];
  filterMetaBestDeals: any = {};
  yearsBestDeals = ['All'];
  makesBestDeals = ['All'];
  modelsBestDeals = ['All'];
  fuelTypesBestDeals = ['All'];
  selectedYearBestDeals = 'All';
  selectedMakeBestDeals = 'All';
  selectedModelBestDeals = 'All';
  selectedFuelTypeBestDeals = 'All';


  constructor(
    private activatedRoute: ActivatedRoute,
    private carsService: CarsService,
    private calculatorService: CalculatorService,
    private cognitoService: CognitoService,
    public dialogService: NbDialogService,
    private breakpointObserver: BreakpointObserver,
    public dialog: MatDialog,
    private componentFactoryResolver: ComponentFactoryResolver,
    private overlay: Overlay,
    private viewContainerRef: ViewContainerRef,
    private authService: AuthenticateService,
    private router: Router,
    private el: ElementRef,
    private cookieService: CookieService,
    private cookieConsentService: NgcCookieConsentService,
    private zone: NgZone,
    public priceService: NigeriaPriceService,
    private languageService: LanguageService,
    // private componentPortal: ComponentPortal<LoadingSpinnerComponent>
  ) {
    // Specify LoadingSpinnerComponent
    // const loadingPortal = new ComponentPortal<LoadingSpinnerComponent>(LoadingSpinnerComponent);
  }

  get isNIGERIARoute(): boolean {
    return this.router.url.startsWith('/nigeria');
  }

  @ViewChild('host', { read: ViewContainerRef }) host: ViewContainerRef;
  // calcRef: ComponentRef<CalculatorCarsComponent>;
  isLoading = new BehaviorSubject<boolean>(false);
  vehicleValue = new BehaviorSubject<any>(null);

  fasFaHeart = fasFaHeart;
  farFaHeart = farFaHeart;
  // faCartPlus = faCartPlus;
  faShoppingCart = faShoppingCart;


  cars = [];
  damagedCars: any[] = [];
  fetchedCars = [];
  fetchedDamagedCars = [];
  currencies: any;
  carById: any; // fetched by link id, since we work by random and filter

  filterMetaCars: any[] = [];
  filterMetaYears: any[] = [];
  filterMetaMakes = [];
  filterMetaFuelTypes = [];
  filterMetaModels = [];

  // protected readonly faMapMarkerAlt = faMapMarkerAlt;

  years = ['All'];
  makes = ['All'];
  models = ['All'];
  fuelTypes = ['All'];

  selectedYear = 'All';
  selectedMake = 'All';
  selectedModel = 'All';
  selectedFuelType = 'All';

  isFilterCollapsed = false;

  isDialogOpen = false;
  showDirham = true;

  showScrollButton = true;

  ngOnInit() {

    if (this.isNIGERIARoute) {
      // Nigeria market is English-only.
      this.languageService.setLanguage('en');
      this.cookieConsentService.hasConsented();
      this.cookieConsentService.close(false);
      this.cookieConsentService.destroy();
    }

    // Single Available Cars view only — ignore any persisted tab cookie.
    this.selectedTab = 1;

    dataLayer.push({
      event: 'button_click_toggle_Tab_pub',
      item_id: +this.selectedTab,
      item_name: +this.selectedTab === 1 ? 'public market' : 'public collector',
      // item_price: 0,
      // item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id') ?? -1,
      userId: sessionStorage.getItem('user-id') ?? -1,
    });
    this.isFilterCollapsed = this.isMobileView();
    // this.showDirham = sessionStorage.getItem('user-id') === '530';
    // window.addEventListener('scroll', this.onWindowScroll, true);
    // this.initialize();
  }

  ngOnChanges(changes: SimpleChanges) {
    // if (changes.selected && changes.selected.currentValue === true) {
    //   window.addEventListener('scroll', this.onWindowScroll, true);
    //   // this.updateOnTabSelection();
    // } else {
    //   window.removeEventListener('scroll', this.onWindowScroll, true);
    // }
  }

  @HostListener('scroll', ['$event'])
  onContentScroll($event: Event) {
    const scrollElement = $event.target as HTMLElement;
    // Ensure we are targeting the correct scrollable container
    if (scrollElement && scrollElement.classList.contains('mat-tab-body-content')) {
      this.zone.run(() => {
        this.showScrollButton = scrollElement.scrollTop > 400;
      });
    }
  }

  scrollToTop() {
    // Find the currently active tab body content
    const activeTabContent = this.el.nativeElement.querySelector('.mat-tab-body-active .mat-tab-body-content');
    if (activeTabContent) {
      activeTabContent.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  ngOnDestroy() {
    // window.removeEventListener('scroll', this.onWindowScroll, true);
  }

  getCarPrice(car: any) {
    // Nigeria market: the API returns the Nigerian landed cost (USD) in C_Price.
    return car.C_Price;
  }

  castUSDToDirham(usd: number): number {
    const conversionRate = 3.67; // Example conversion rate, please use the current rate
    return usd * conversionRate;
  }

  // Method to convert EUR to Dirham
  castEURToDirham(eur: number): number {
    const conversionRate = 4.05; // Example conversion rate, please use the current rate
    return eur * conversionRate;
  }

  // onScroll(event: any): void {
  //   const element = event.target;
  //   console.log(`scrollTop: ${element.scrollTop}, scrollHeight: ${element.scrollHeight}
  //   , offsetHeight: ${element.offsetHeight}, clientHeight: ${element.clientHeight}`);
  //   if (element.scrollHeight - element.scrollTop <= element.clientHeight + 1) {
  //     console.log('load  0 -------');
  //     // Reached the bottom of the scrollable area
  //     if (!this.isLoading) {
  //       console.log('load -------');
  //       // this.loadMoreItems();
  //     }
  //   }
  // }



  resetScroll = () => {
    // this.target?.removeEventListener('scroll', this.onWindowScroll, true);
    // this.target?.scrollTo({ top: 0, behavior: 'smooth' });
    // this.target?.addEventListener('scroll', this.onWindowScroll, true);
  }

  onWindowScroll = (event: any): void => {

    if (this.isDialogOpen) {
      return;
    }

    // console.log(event);
    // const element = document.getElementById('cardContainer');
    const element = event.target;

    this.target = element;
    if (element) {
      const pos = element.scrollTop + element.offsetHeight;
      const max = element.scrollHeight;

      if (pos >= max) {
        console.log('load ---------');
        // Your logic to load more items or whatever you want to do when reaching the bottom


        const params = {
          page: this.page + 1,
          year: this.year,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: this.priceRange,
          kmRange: this.kmRange,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
          userId: this.sellerId
        };

        // console.log(pos, max);


        this.loadMoreItems(params);

      }
    }
  }

  async toggleMoreInfo(car: any) {
    if (this.activeDialogRef) {
      return; // prevent duplicate open
    }

    try {
      const selectedCar = car;
      const isMobile = this.isMobileView();

      dataLayer.push({
        event: 'button_click_more_info_list_coll_pub',
        item_id: selectedCar.id,
        item_name: selectedCar.Manufacturer + ' ' + selectedCar.Model,
        item_price: selectedCar.CarPrice,
        item_year: selectedCar.ManufactureDate,
        user_id: sessionStorage.getItem('user-id') ?? -1,
        userId: sessionStorage.getItem('user-id') ?? -1,
      });

      const baseDialogConfig: Omit<NbDialogConfig<any>, 'context'> = {
        hasBackdrop: true,
        closeOnEsc: true,
        backdropClass: '',
        dialogClass: isMobile ? 'full-screen-dialog' : '',
        closeOnBackdropClick: false,
        hasScroll: false,
        autoFocus: true,
        viewContainerRef: undefined,
      };

      const dialogContext: Partial<CarModalSellerNigeriaComponent> & Partial<CarModalNigeriaComponent> & CarModalDialogContext = {
        isCarMarket: true,
        source: 'personal',
        data: selectedCar ?? {},
        currencies: this.currencies,
        isLoadingCalc: this.isLoading,
        vehicleValue: this.vehicleValue,
        importType: this.importType,
        caller: 'cars-grid-seller-nigeria.toggleMoreInfo',
        callerRoute: this.router.url,
        openedAt: Date.now(),
        extra: {
          selectedTab: this.selectedTab,
          sellerId: this.sellerId,
          isMobile,
        },
      };

      const sellerDialogConfig: NbDialogConfig<Partial<CarModalSellerNigeriaComponent>> = {
        ...baseDialogConfig,
        context: dialogContext,
      };

      const nigeriaDialogConfig: NbDialogConfig<Partial<CarModalNigeriaComponent>> = {
        ...baseDialogConfig,
        context: dialogContext,
      };

      try {
        if (!isMobile) {
          this.activeDialogRef = this.dialogService.open(CarModalSellerNigeriaComponent, sellerDialogConfig);
           this.activeDialogRef.onClose.subscribe((result: any) => {
             this.router.navigate([], {
               queryParams: {
                 id: null,
                 importType: this.importType,
                 tab: this.selectedTab
               },
               queryParamsHandling: 'merge'
             });
            const dialogResult = result ?? sellerDialogConfig.context.data;
             console.log('Dialog closed', dialogResult);
             dataLayer.push({
               event: 'cars-grid-dialog-closed_coll_pub',
               item_id: dialogResult.id,
               item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
               item_price: dialogResult.CarPrice,
               item_year: dialogResult.ManufactureDate,
             });
             this.activeDialogRef = null;
           });
         } else {
          this.activeDialogRef = this.dialogService.open(CarModalNigeriaComponent, nigeriaDialogConfig);
           this.activeDialogRef.componentRef.instance.nbDialogRef = this.activeDialogRef;
           this.activeDialogRef.onClose.subscribe((result: any) => {
             this.router.navigate([], {
               queryParams: {
                 id: null,
                 importType: this.importType,
                 tab: this.selectedTab
               },
               queryParamsHandling: 'merge'
             });
            const dialogResult = result ?? nigeriaDialogConfig.context.data;
             console.log('Dialog closed', dialogResult);
             dataLayer.push({
               event: 'cars-grid-dialog-closed_coll_pub',
               item_id: dialogResult.id,
               item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
               item_price: dialogResult.CarPrice,
               item_year: dialogResult.ManufactureDate,
             });
             this.activeDialogRef = null;
           });
         }
      } finally {
        // If dialog was not opened for some reason, ensure activeDialogRef is null
        // (do not clear here if dialogRef set, only on close)
      }
    } catch (err) {
      console.log(err);
      this.isDialogOpen = true;
      const loginRequest = this.dialog.open(LoginModalComponent,
        {
          width: this.isMobileView() ? '400px' : '450px',
          panelClass: 'custom-dialog-padding'
        });
      loginRequest.afterClosed().subscribe(async (res) => {
        if (!res || !res.approve) {
          // this.router.navigate(['/account']);
        } else {
          const selectedCar = await this.carsService.getCarById(car.id, 'personal').toPromise();
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: {
              id: selectedCar.id,
              importType: this.importType,
              tab: this.selectedTab
            },
            queryParamsHandling: 'merge'
          });
          dataLayer.push({
            event: 'button_click_more_info_list_coll_pub',
            item_id: selectedCar.id,
            item_name: selectedCar.Manufacturer + ' ' + selectedCar.Model,
            item_price: selectedCar.CarPrice,
            item_year: selectedCar.ManufactureDate,
            user_id: sessionStorage.getItem('user-id') ?? -1,
            userId: sessionStorage.getItem('user-id') ?? -1,
          });
          const isMobile = this.isMobileView();
          const dialogConfig: NbDialogConfig<any> = {
            hasBackdrop: true,
            closeOnEsc: true,
            backdropClass: '',
            dialogClass: isMobile ? 'full-screen-dialog' : '',
            closeOnBackdropClick: false,
            hasScroll: false,
            autoFocus: false,
            viewContainerRef: undefined,
            context: {
              data: car ?? {},
              currencies: this.currencies,
              isLoadingCalc: this.isLoading,
              vehicleValue: this.vehicleValue,
              importType: this.importType,
            }
          };
          try {
            const dialogRef = this.dialogService.open(CarModalComponent, dialogConfig);
            if (isMobile) {
              dialogRef.componentRef.instance.nbDialogRef = dialogRef;
            }
            dialogRef.onClose.subscribe((result: any) => {
              this.router.navigate([], {
                queryParams: {
                  id: null,
                  importType: this.importType,
                  tab: this.selectedTab
                },
                queryParamsHandling: 'merge'
              });
              const dialogResult = result ?? dialogConfig.context.data;
              console.log('Dialog closed', dialogResult);
              dataLayer.push({
                event: 'cars-grid-dialog-closed_coll_pub',
                item_id: dialogResult.id,
                item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
                item_price: dialogResult.CarPrice,
                item_year: dialogResult.ManufactureDate,
              });
              // No need to clear activeDialogRef here, as it's not used in this branch
              if (result?.code === 200) {
                // this.refreshCars();
              }
            });
          } finally {
            // nothing to do
          }
          this.isDialogOpen = false;
        }
      });
    }
  }

  handleLoadMore = (): void => {
    if (this.isDialogOpen) {
      return;
    }

    console.log('load ---------');

    const isBestDealsTab = this.selectedTab === 0;
    const isDamagedTab = this.selectedTab === 2;

    const activeYear = isDamagedTab
      ? this.selectedYearDamaged
      : isBestDealsTab
        ? this.selectedYearBestDeals
        : this.selectedYearNormal;

    const activeMake = isDamagedTab
      ? this.selectedMakeDamaged
      : isBestDealsTab
        ? this.selectedMakeBestDeals
        : this.selectedMakeNormal;

    const activeModel = isDamagedTab
      ? this.selectedModelDamaged
      : isBestDealsTab
        ? this.selectedModelBestDeals
        : this.selectedModelNormal;

    const activeFuelType = isDamagedTab
      ? this.selectedFuelTypeDamaged
      : isBestDealsTab
        ? this.selectedFuelTypeBestDeals
        : this.selectedFuelTypeNormal;

    const params = {
      page: this.page + 1,
      year: activeYear === 'All' ? -1 : parseInt(activeYear, 10),
      make: activeMake === 'All' ? '' : activeMake,
      model: activeModel === 'All' ? '' : activeModel,
      fueltype: activeFuelType === 'All' ? '' : activeFuelType,
      priceRange: `${this.sliderValue}-${this.serverPriceHigh()}`,
      kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
      locatedInIsrael: this.locatedInIsrael,
      saleCondition: this.saleCondition,
      importType: this.importType,
      userId: this.sellerId
    };

    this.loadMoreItems(params);
  }

  async initialize() {
    // await this.checkUserAuthentication();
    this.createOverlay();
    this.loadData();
  }

  async checkUserAuthentication() {
    const userId = sessionStorage.getItem('user-id');
    if (!userId) {
      this.authService.checkAuth().subscribe((res: any) => {
        if (res.code === 200) {
          sessionStorage.setItem('user-id', res.data.id);
          // Your dataLayer logic
        }
      });
    }
  }

  createOverlay() {
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([
          {
            originX: 'center',
            originY: 'center',
            overlayX: 'center',
            overlayY: 'center',
          },
        ]),
    });

    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
    this.overlayRef.attach(loadingPortal);
  }

  loadData() {
    forkJoin([
      this.carsService.filterPagedNIGERIA({
        page: 1, year: this.year, make: this.make, model: this.model, fueltype: this.fueltype,
        priceRange: this.priceRange, kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael, saleCondition: this.saleCondition,
        importType: this.importType, userId: this.sellerId
      }),
      this.carsService.getFilterMetaNIGERIA(this.sellerId, 'nigeria')
    ]).subscribe(([cars, filterMetaNormal]) => {

      // --- Normal Cars (the single Available Cars view) ---
      this.cars = cars.map(car => ({ ...car, isLiked: car.interest === 'Liked' }));
      this.fetchedCars = this.cars;
      this.filterMetaNormal = filterMetaNormal;

      this.yearsNormal = ['All'].concat(filterMetaNormal.years || []);
      this.makesNormal = ['All'].concat(filterMetaNormal.manufacturers?.map(m => m.make) || []);
      this.modelsNormal = ['All'].concat(
        [].concat(...(filterMetaNormal.cars?.map(v => v.model.map(m => m.name)) || []))
      );
      this.fuelTypesNormal = ['All'].concat(filterMetaNormal.fueltypes?.map(f => f.name) || []);

      // --- Shared filters (compatibility for legacy dropdowns) ---
      this.filterMetaCars = filterMetaNormal.cars;
      this.filterMetaModels = [].concat(...this.filterMetaCars?.map(vehicle => vehicle.model) || []);
      this.filterMetaFuelTypes = ['All'].concat(filterMetaNormal.fueltypes || []);
      this.filterMetaYears = ['All'].concat(filterMetaNormal.years || []);
      this.filterMetaMakes = filterMetaNormal.manufacturers;

      // Shared simple lists
      this.years = this.yearsNormal;
      this.makes = this.makesNormal;
      this.models = this.modelsNormal;
      this.fuelTypes = this.fuelTypesNormal;
      this.hasMore = cars.length !== 0;
      this.recomputePriceCeiling();

      // --- Finalize ---
      this.overlayRef.detach();
      this.handleQueryParams();
    });
  }

  loadData_old() {
    forkJoin([
      this.carsService.filterPagedNIGERIA({
        page: 1,
        year: this.year,
        make: this.make,
        model: this.model,
        fueltype: this.fueltype,
        priceRange: this.priceRange,
        kmRange: this.kmRange,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      }),
      // this.calculatorService.getCurrencies(),
      this.carsService.getFilterMetaNIGERIA(this.sellerId, 'nigeria'),
    ]).subscribe(([cars, filterMeta]) => {
      this.cars = cars.map((car) => ({
        ...car,
        isLiked: car.interest === 'Liked'
      }));
      this.fetchedCars = this.cars;

      // this.currencies = currencies.data;
      console.log(filterMeta);
      this.filterMetaCars = filterMeta.cars;

      // debugger;

      this.filterMetaModels = [].concat(...this.filterMetaCars?.map(vehicle => vehicle.model) || []);

      this.filterMetaFuelTypes = ['All'].concat(filterMeta.fueltypes || []);
      this.fuelTypes = ['All'].concat(filterMeta.fueltypes?.map((fuelType) => fuelType.name) || []);
      this.filterMetaYears = ['All'].concat(filterMeta.years || []);


      this.filterMetaMakes = filterMeta.manufacturers;
      this.makes = ['All'].concat(filterMeta.manufacturers?.map((manufacturer) => manufacturer.make) || []);
      // console.log(this.cars);
      // console.log(new Date().getTime());

      this.overlayRef.detach();

      this.handleQueryParams();

      this.hasMore = cars.length !== 0;
    });
  }

  handleQueryParams() {

    this.activatedRoute.queryParams
      .pipe(
        switchMap(async (params) => {
          const id = params['id'];
          this.importType = params['importType'] ?? 'Commercial';
          // Single Available Cars view only — always force the available tab.
          this.selectedTab = 1;
          if (id) {
            return await this.getCarDataById(id);
          }
          const dialogResult = this.carsService.carResponseSubject.value;
          if (dialogResult) {
            dataLayer.push({
              event: 'cars-grid-dialog-closed_coll_pub',
              item_id: dialogResult.id,
              item_name: dialogResult.Manufacturer + ' ' + dialogResult.Model,
              item_price: dialogResult.CarPrice,
              item_year: dialogResult.ManufactureDate,
            });
          }
          return null;
        })
      )
      .subscribe(
        (carData) => {
          if (carData) {
            this.toggleMoreInfo(carData).then(() => { });
          }
        },
        (error) => {
          console.error(`An error occurred: ${error}`);
        }
      );
  }

  loadMoreItems(params: any) {
    this.carsService.filterPagedNIGERIA(params).subscribe((cars: any) => {
      this.cars = [
        ...this.cars,
        ...cars.map((car) => ({ ...car, isLiked: car.interest === 'Liked' }))
      ];
      this.fetchedCars = this.cars;

      this.page++;
      this.hasMore = cars.length !== 0;
      this.recomputePriceCeiling();
      console.log('page', this.page);
    });
  }

  async getCarDataById(id: string, customerType: string = 'Commercial'): Promise<any> {
    let carById = this.cars.find((car) => car.id === +id)
      || this.damagedCars.find((car) => car.id === +id);
    if (!carById) {
      const cars = await this.carsService.getCarByIdNew(+id, customerType).toPromise();
      carById = cars[0];
    }
    return carById;
  }

  // async getCarDataById(id: string, customerType: string = 'Commercial'): Promise<any> {
  //   let carById = this.cars.find((car) => car.id === +id);
  //   if (!carById) {
  //     const cars = await this.carsService.getCarByIdNew(+id, customerType).toPromise();
  //     carById = cars[0];
  //   }
  //   return carById;
  // }

  ngAfterViewInit() {
    const userId = sessionStorage.getItem('user-id');
    // const dialog = this.dialog.open(AcceptTermsComponent, {
    //   width: '100%'
    // });
    // dialog.afterClosed().subscribe(result => {
    //   if (!result) {
    //     this.router.navigate(['/account/calculate']);
    //   }
    //   if (result.approve) {
    this.initialize();
    this.isLoading.next(true);
    const factory = this.componentFactoryResolver.resolveComponentFactory(CalculatorCarsComponent);

    //     this.isLoading.next(false);
    //   } else {
    //     this.router.navigate(['/auth/login']);
    //   }
    // });
  }

  openDialog(car: any): void {
    this.dialog.open(CarDialogOverviewComponent, {
      width: '80vw',
      data: { car }
    });
  }

  toggleLike(car) {
    car.isLiked = !car.isLiked;
    const interest = car.isLiked ? 'Liked' : 'Disliked';
    this.carsService.updateNIGERIAInterest(car.id, interest, this.importType).subscribe((res: any) => {
      console.log(res);
    });
  }

  toggleInterest(car) {
    this.carsService.updateNIGERIAInterest(car.id, 'Interested', this.importType).subscribe((res: any) => {
      console.log(res);
    });
  }

  isMobileView(): boolean {
    return this.breakpointObserver.isMatched(Breakpoints.Handset);
  }

  async handleClick(car: any) {
    await this.router.navigate([], {
      queryParams: {
        id: car.id,
        importType: this.importType,
        tab: this.selectedTab
      },
      queryParamsHandling: 'merge'
    });
  }


  getExwByExwId(data: any, id) {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw;
        }
      }
    }

    return null;
  }

  getHarborByExwId(data, id) {
    return data.options.find(option =>
      option.exw.some(exw => exw.id === id)
    );
  }

  getDisHarborByExwId = (data, id) => {
    for (const option of data.options) {
      for (const exw of option.exw) {
        if (exw.id === id) {
          return exw.dHarbor;
        }
      }
    }

    return null;
  }

  onYearChange0(year: string) {
    this.selectedYear = year;
    // this.selectedMake = 'All';
    // this.selectedModel = 'All';
    // this.selectedFuelType = 'All';
  }

  onMakeChange0(make: string) {
    this.selectedMake = make;
    console.log('selected make', this.selectedMake);
    console.log('filterMetaCars', this.filterMetaCars);
    // debugger;
    this.models = Array.from(new Set(
      ['All'].concat(
        this.filterMetaCars
          .filter((car) => car.make === make)
          .map((car) => car.model.map((model: any) => model.name))
          .reduce((acc, val) => acc.concat(val), [])
      )
    ));

    this.selectedModel = 'All';


  }

  onModelChange0(model: string) {
    this.selectedModel = model;
  }

  onFuelChange0(fuel: string) {
    this.selectedFuelType = fuel;
  }

  onYearChange(year: string) {
    if (this.selectedTab === 2) {
      this.selectedYearDamaged = year;
    } else if (this.selectedTab === 0) {
      this.selectedYearBestDeals = year;
    } else {
      this.selectedYearNormal = year;
    }
  }

  onMakeChange(make: string) {
    if (this.selectedTab === 2) {
      this.selectedMakeDamaged = make;
      const cars = this.filterMetaDamaged.cars || [];
      const filteredCars = make === 'All' ? cars : cars.filter((car) => car.make === make);
      this.modelsDamaged = ['All'].concat(
        (Array.from(new Set(filteredCars
          .map((car) => car.model.map((m: any) => m.name))
          .reduce((acc: any[], val: any) => acc.concat(val), [] as any[]) || [])) as string[]).sort()
      );
      this.models = this.modelsDamaged;
      this.selectedModelDamaged = 'All';
    } else if (this.selectedTab === 0) {
      this.selectedMakeBestDeals = make;
      const cars = this.filterMetaBestDeals.cars || [];
      const filteredCars = make === 'All' ? cars : cars.filter((car) => car.make === make);
      this.modelsBestDeals = ['All'].concat(
        (Array.from(new Set(filteredCars
          .map((car) => car.model.map((m: any) => m.name))
          .reduce((acc: any[], val: any) => acc.concat(val), [] as any[]) || [])) as string[]).sort()
      );
      this.models = this.modelsBestDeals;
      this.selectedModelBestDeals = 'All';
    } else {
      this.selectedMakeNormal = make;
      const cars = this.filterMetaNormal.cars || [];
      const filteredCars = make === 'All' ? cars : cars.filter((car) => car.make === make);
      this.modelsNormal = ['All'].concat(
        (Array.from(new Set(filteredCars
          .map((car) => car.model.map((m: any) => m.name))
          .reduce((acc: any[], val: any) => acc.concat(val), [] as any[]) || [])) as string[]).sort()
      );
      this.models = this.modelsNormal;
      this.selectedModelNormal = 'All';
    }
  }

  onModelChange(model: string) {
    if (this.selectedTab === 2) {
      this.selectedModelDamaged = model;
    } else if (this.selectedTab === 0) {
      this.selectedModelBestDeals = model;
    } else {
      this.selectedModelNormal = model;
    }
  }

  onFuelChange(fuel: string) {
    if (this.selectedTab === 2) {
      this.selectedFuelTypeDamaged = fuel;
    } else if (this.selectedTab === 0) {
      this.selectedFuelTypeBestDeals = fuel;
    } else {
      this.selectedFuelTypeNormal = fuel;
    }
  }


  toggleFilter() {
    this.isFilterCollapsed = !this.isFilterCollapsed;
  }


  filter(type: string = 'normal') {
    this.loading = true;

    const activeSelectedMake = this.selectedMakeNormal;
    const activeSelectedModel = this.selectedModelNormal;
    const activeSelectedFuelType = this.selectedFuelTypeNormal;
    const activeYear = this.selectedYearNormal;

    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay.position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([{ originX: 'center', originY: 'center', overlayX: 'center', overlayY: 'center' }])
    });

    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);
    this.overlayRef.attach(loadingPortal);

    // Handle the single Available Cars filtering
    if (['normal', 'damaged', 'bestDeals'].includes(type)) {
      const params = {
        page: 1,
        year: activeYear === 'All' ? -1 : parseInt(activeYear, 10),
        make: activeSelectedMake === 'All' ? '' : activeSelectedMake,
        model: activeSelectedModel === 'All' ? '' : activeSelectedModel,
        fueltype: activeSelectedFuelType === 'All' ? '' : activeSelectedFuelType,
        priceRange: `${this.sliderValue}-${this.serverPriceHigh()}`,
        kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
        locatedInIsrael: this.locatedInIsrael,
        saleCondition: this.saleCondition,
        importType: this.importType,
        userId: this.sellerId
      };

      this.carsService.filterPagedNIGERIA(params).subscribe((cars: any) => {
        this.cars = cars.map(c => ({ ...c, isLiked: c.interest === 'Liked' }));
        this.fetchedCars = this.cars;
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }

    // Handle "liked" and "interested" independently
    else if (type === 'interested') {
      this.carsService.filterInterested({}).subscribe((cars: any) => {
        this.cars = cars.map(c => ({ ...c, isLiked: c.interest === 'Liked' || c.interest === 'RequestedMoreInfo' }));
        this.fetchedCars = this.cars;
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }

    else if (type === 'liked') {
      this.carsService.filterLiked({}).subscribe((cars: any) => {
        this.cars = cars.map(c => ({ ...c, isLiked: true }));
        this.fetchedCars = this.cars;
        this.loading = false;
        this.overlayRef.detach();
        this.resetScroll();
      });
    }

    this. scrollToTop();
  }
  // type = normal | interested | liked
  filter_old(type: string = 'normal') {
    this.loading = true;
    // Show overlay
    this.overlayRef = this.overlay.create({
      hasBackdrop: true,
      backdropClass: 'loading-backdrop',
      positionStrategy: this.overlay
        .position()
        .flexibleConnectedTo(this.carContainer)
        .withPositions([{
          originX: 'center',
          originY: 'center',
          overlayX: 'center',
          overlayY: 'center'
        }])
    });


    const loadingPortal = new TemplatePortal(this.loadingOverlay, this.viewContainerRef);

    // const loadingPortal = new ComponentPortal(this.loadingOverlay);
    this.overlayRef.attach(loadingPortal);

    if (type === 'normal') {
      const year = this.selectedYear === 'All' ? -1 : parseInt(this.selectedYear, 0);
      const make = this.selectedMake === 'All' ? '' : this.filterMetaMakes.find((m: any) => m.make === this.selectedMake)?.make ?? '';

      // TODO: fix this
      const model = this.selectedModel === 'All' ? '' : this.selectedModel;

      // TODO: fix this
      let fueltype = '';
      switch (this.selectedFuelType) {
        case 'All':
          fueltype = '';
          break;
        case 'דיזל':
          fueltype = 'diesel';
          break;
        case 'בנזין':
          fueltype = 'petrol';
          break;
        case 'היברידי':
          fueltype = 'hybrid';
          break;
        case 'חשמלי':
          fueltype = 'electric';
          break;
        case 'פלאג אין':
          fueltype = 'plug-in';
          break;

      }
      // const fueltype = this.selectedFuelType === 'All'
      //     ? ''
      //     : this.filterMetaModels.find((m: any) => m?.fuelType_h === this.selectedFuelType)?.fuelType ?? '';

      this.year = year,
        this.make = make,
        this.model = model,
        this.fueltype = this.selectedFuelType,
        this.priceRange = `${this.sliderValue}-${this.serverPriceHigh()}`,
        this.kmRange = `${this.sliderKmValue}-${this.sliderKmHighValue}`,

        this.carsService.filterPagedNIGERIA({
          page: 1,
          year: this.year,
          make: this.make,
          model: this.model,
          fueltype: this.fueltype,
          priceRange: `${this.sliderValue}-${this.serverPriceHigh()}`,
          kmRange: `${this.sliderKmValue}-${this.sliderKmHighValue}`,
          locatedInIsrael: this.locatedInIsrael,
          saleCondition: this.saleCondition,
          importType: this.importType,
          userId: this.sellerId
        })
          .subscribe((cars: any) => {
            this.cars = cars.map((car) => ({
              ...car,
              isLiked: car.interest === 'Liked'
            }));
            this.fetchedCars = this.cars;
            this.filterByRange();
            this.loading = false;
            this.toggleFilter();
            this.overlayRef.detach();
            console.log('reset scroll call');
            this.resetScroll();
            this.hasMore = cars.length !== 0;
          });
    } else if (type === 'interested') {
      this.carsService.filterInterested({})
        .subscribe((cars: any) => {
          this.cars = cars.map((car) => ({
            ...car,
            isLiked: car.interest === 'Liked' || car.interest === 'RequestedMoreInfo'
          }));
          this.fetchedCars = this.cars;
          this.filterByRange();
          this.loading = false;
          this.toggleFilter();
          this.overlayRef.detach();
          this.resetScroll();
        });

    } else if (type === 'liked') {
      this.carsService.filterLiked({})
        .subscribe((cars: any) => {
          this.cars = cars.map((car) => ({
            ...car,
            isLiked: true, // car.interest === 'Liked'
          }));
          this.fetchedCars = this.cars;
          this.filterByRange();
          this.loading = false;
          this.toggleFilter();
          this.overlayRef.detach();
          this.resetScroll();
        });
    }
  }

  // isMobileView() {
  //   // Return true if the screen width is less than or equal to 768px, otherwise false
  //   return window.innerWidth <= 768;
  // }

  onSliderChangeEnd(type: 'price' | 'km', $event: ChangeContext) {
    if (this.filterInProgress) { return; } // skip re-entry

    clearTimeout(this.sliderChangeTimer);

    // Detect redundant ranges (no need to re-filter)
    const sameValues =
      this.lastFilterValues.priceLow === this.sliderValue &&
      this.lastFilterValues.priceHigh === this.sliderHighValue &&
      this.lastFilterValues.kmLow === this.sliderKmValue &&
      this.lastFilterValues.kmHigh === this.sliderKmHighValue &&
      this.lastFilterValues.tab === this.selectedTab;

    if (sameValues) { return; }

    // Save last values snapshot
    this.lastFilterValues = {
      priceLow: this.sliderValue,
      priceHigh: this.sliderHighValue,
      kmLow: this.sliderKmValue,
      kmHigh: this.sliderKmHighValue,
      tab: this.selectedTab
    };

    this.sliderChangeTimer = setTimeout(() => this.safeFilterByRange(), 300);
  }

  private async safeFilterByRange() {
    if (this.filterInProgress) {
      return;
    }

    this.filterInProgress = true;
    try {
      this.filterByRange();
    } finally {
      this.filterInProgress = false;
    }
  }

  onSliderChangeEnd1(type: 'price' | 'km', $event: ChangeContext) {
    clearTimeout(this.sliderChangeTimer);

    // Prevent redundant triggers if same range
    const last = this.lastSliderRange[type];
    if (last.low === $event.value && last.high === $event.highValue) {
      return;
    }

    this.lastSliderRange[type] = {
      low: $event.value,
      high: $event.highValue
    };

    // Debounce filtering to avoid multiple re-renders
    this.sliderChangeTimer = setTimeout(() => {
      this.filterByRange();
    }, 300);
  }

  onSliderChangeEnd_old($event: ChangeContext) {
    console.log($event);
    // this.sliderValue = $event.value;
    // this.sliderHighValue = $event.highValue;
    this.filterByRange();
    console.log(this.cars.length);
  }

  onSliderKmChangeEnd($event: ChangeContext) {
    console.log($event);
    // this.sliderValue = $event.value;
    // this.sliderHighValue = $event.highValue;
    this.filterByRange();
    console.log(this.cars.length);
  }
  onKmSliderEnd(event: ChangeContext) {
    this.sliderKmValue = event.value;
    this.sliderKmHighValue = event.highValue;
    this.applyRangeFilterSafely();
  }

  filterByRange() {
    const isBestDealsTab = this.selectedTab === 0;
    const isDamagedTab = this.selectedTab === 2;

    const baseCars = isBestDealsTab
      ? this.fetchedBestDealsCars
      : isDamagedTab
        ? this.fetchedDamagedCars
        : this.fetchedCars;

    const filtered = baseCars.filter((car) => {
      const price = car.C_Price ?? 0;
      const km = car.Mileage ?? 0;

      const highBound = this.isPriceAtMax ? CarsGridSellerNigeriaComponent.NG_PRICE_UNBOUNDED : this.sliderHighValue;
      const inPriceRange = price >= this.sliderValue && price <= highBound;
      const inKmRange = km >= this.sliderKmValue && km <= this.sliderKmHighValue;

      return inPriceRange && inKmRange;
    });

    if (isBestDealsTab) {
      this.bestDealsCars = filtered;
    } else if (isDamagedTab) {
      this.damagedCars = filtered;
    } else {
      this.cars = filtered;
    }
  }

  onPriceSliderEnd(event: ChangeContext) {
    this.sliderValue = event.value;
    this.sliderHighValue = event.highValue;
    this.applyRangeFilterSafely();
  }

  // The top of the slider means "no upper limit" so pricier cars are never hidden.
  private static readonly NG_PRICE_UNBOUNDED = 1000000; // USD landed; excludes only absurd data errors
  get isPriceAtMax(): boolean {
    return this.sliderHighValue >= ((this.sliderOptions.ceil as number) ?? 200000);
  }
  private serverPriceHigh(): number {
    return this.isPriceAtMax ? CarsGridSellerNigeriaComponent.NG_PRICE_UNBOUNDED : this.sliderHighValue;
  }

  // Scale the slider's max to the actual inventory so the usable range isn't crammed at the bottom.
  private priceCeilInitialized = false;
  private recomputePriceCeiling() {
    const prices = (this.fetchedCars || [])
      .map((c: any) => +c.C_Price).filter((p: number) => p > 0).sort((a: number, b: number) => a - b);
    if (!prices.length) { return; }
    const p95 = prices[Math.min(prices.length - 1, Math.floor(prices.length * 0.95))];
    let ceil = Math.ceil(p95 / 5000) * 5000;            // round up to nearest 5k USD
    ceil = Math.max(30000, Math.min(ceil, 150000));     // sensible bounds
    if (this.priceCeilInitialized) {
      ceil = Math.max(ceil, this.sliderOptions.ceil as number); // only grow after first load
    }
    this.priceCeilInitialized = true;
    const wasAtMax = this.isPriceAtMax;
    this.sliderOptions = { ...this.sliderOptions, ceil };
    if (wasAtMax || this.sliderHighValue > ceil) { this.sliderHighValue = ceil; }
  }

  private applyRangeFilterSafely() {
    if (this.filterLock) {
      return;
    }

    clearTimeout(this.filterDebounce);
    this.filterDebounce = setTimeout(() => {
      this.filterLock = true;

      try {
        this.filterByRange();
      } finally {
        setTimeout(() => (this.filterLock = false), 400);
      }
    }, 250);
  }

  filterByRange2() {
    this.cars = this.fetchedCars;
    console.log(this.cars);
    this.cars = this.cars.filter((car) => {
      return (car.C_Price >= this.sliderValue && car.C_Price <= this.sliderHighValue) &&
        (car.Mileage >= this.sliderKmValue && car.Mileage <= this.sliderKmHighValue) &&
        ((car.Location === 'Israel' && this.locatedInIsrael === 'Yes')
          || (car.Location !== 'Israel' && this.locatedInIsrael === 'No')
          || this.locatedInIsrael === 'All') &&
        ((car.SaleCondition === 'New' && this.saleCondition === 'New')
          || (car.SaleCondition !== 'New' && this.saleCondition === 'Used')
          || this.saleCondition === 'All');
      // && ((car.importType === 'Commercial' && this.saleCondition === 'Commercial')
    });
  }

  onLocationToggleChange($event: any): void {
    this.filterByRange();
  }

  onCarSaleConditionToggleChange($event: any): void {
    this.filterByRange();
  }

  onCarImportTypeToggleChange($event: any): void {
    this.router.navigate([], {
      queryParams: {
        id: null,
        importType: this.importType,
        tab: this.selectedTab
      },
      queryParamsHandling: 'merge'
    });
    this.filterByRange();
  }


  getFuelTypeHebrew(type: any) {
    if (this.showDirham) { return type; }

    switch (type) {
      case '':
        return '';
      case 'diesel':
        return 'דיזל';
      case 'petrol':
        return 'בנזין';
      case 'hybrid':
        return 'היברידי';
      case 'electric':
        return 'חשמלי';
      case 'plug-in':
        return 'פלאג אין';

    }
  }

  onTabIndexChanged($event: number) {
    // Single Available Cars view only — force the normal/available view.
    this.selectedTab = 1;
    this.cookieService.set('selectedTab', '1');

    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams: { tab: this.selectedTab },
      queryParamsHandling: 'merge',
    });

    // Reset filters
    this.selectedYearNormal = 'All';
    this.selectedYear = 'All';
    this.selectedMakeNormal = 'All';
    this.selectedModelNormal = 'All';
    this.selectedFuelTypeNormal = 'All';

    this.sliderValue = 0;
    this.sliderHighValue = 200000;
    this.sliderKmValue = 0;
    this.sliderKmHighValue = 1000000;
    this.locatedInIsrael = 'All';
    this.saleCondition = 'All';

    this.years = this.yearsNormal;
    this.makes = this.makesNormal;
    this.models = this.modelsNormal;
    this.fuelTypes = this.fuelTypesNormal;
    this.selectedMake = this.selectedMakeNormal;
    this.selectedModel = this.selectedModelNormal;
    this.selectedFuelType = this.selectedFuelTypeNormal;

    this.loadData();
  }

  onTabIndexChanged_old($event: number) {
    this.selectedTab = (+$event || 0);
    this.cookieService.set('selectedTab', $event.toString());

    dataLayer.push({
      event: 'button_click_toggle_Tab_pub',
      item_id: $event,
      item_name: $event === 0 ? 'public market' : 'public collector',
      // item_price: 0,
      // item_year: car.ManufactureDate,
      user_id: sessionStorage.getItem('user-id') ?? -1,
      userId: sessionStorage.getItem('user-id') ?? -1,
    });

    // if (this.selectedTab === 0) {
    //   window.addEventListener('scroll', this.onWindowScroll, true);
    //   // this.updateOnTabSelection();
    // } else {
    //   window.removeEventListener('scroll', this.onWindowScroll, true);
    // }
  }

  handleImageError(car: any): void {
    if (car.Source !== 'Manual') {
      car.url = null;
    } else {
      car.url = '/assets/images/nocarph.jpg';
    }
  }

  showArbDisclaimer(car: any) {
    const dialog = this.dialog.open(ArbitrageTermsNigeriaComponent, {
      width: '100%'
    });
  }

  getArbitrageDiff(car: any): string | null {
    if (car.ArbitragePrice == null) {
      return null;
    }
    const diff = car.ArbitragePrice - car.C_Price;
    return diff > 0 ? `+${diff}` : null;
  }
}
